<template>
    <swiper :modules="modules" :slides-per-view="perViewNum" grid="{fill: 'row', rows:1}" :space-between="10"
        @swiper="onSwiper" @slideChange="onSlideChange" navigation loop="true"
        style="min-width: 800px; margin-top: 10px; margin-bottom: 10px">
        <swiper-slide v-for="tage in tageList" :key="tage.tag_id" style="height: 50px; width: fit-content;">
            <router-link :to="{ name: 'search', query: { tag: tage.title } }">
                <el-tag type="success" effect="dark" class="tage-button">
                    {{ tage.title }}
                </el-tag>
            </router-link>
        </swiper-slide>
        <!-- <div class="swiper-button-prev"></div> -->
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

export default {
    props: {
        tageList: {
            type: Array,
            default: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        }
    },
    data() {
        return {
            perViewNum: 'auto'
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        const onSwiper = (swiper) => {
            console.log(swiper);
        };
        const onSlideChange = () => {
            console.log('slide change');
        };
        return {
            onSwiper,
            onSlideChange,
            modules: [Navigation],
        };
    },
};
</script>

<style scoped>
.tage-button {
    width: fit-content;
    height: 50px;
}
</style>
